<template>
  <div class="app-container container">

    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch">
      <el-form-item label="用户名称" prop="userName">
        <el-input v-model="queryParams.userName" placeholder="请输入用户名称" clearable @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <!-- <el-form-item label="手机号码" prop="mobile">
        <el-input v-model="queryParams.mobile" placeholder="请输入手机号码" clearable style="width: 240px"
                  @keyup.enter.native="handleQuery"/>
      </el-form-item> -->
      <el-form-item label="状态" >
            <el-select v-model="queryParams.status">
              <el-option value="0" label="开启"></el-option>
              <el-option value="1" label="关闭"></el-option>
            </el-select>
        </el-form-item>
      <el-form-item label="类型" >
            <el-select v-model="queryParams.type">
              <el-option label="爱好者" :value="1"/>
              <el-option label="学生用户" :value="2"/>
              <el-option label="校园用户" :value="3"/>
              <el-option label="活动评委" :value="91"/>
              <el-option label="后台用户" :value="10"/>
            </el-select>
        </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery" v-preventReClick>搜索</el-button>
        <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button type="primary" plain icon="el-icon-plus" size="mini" @click="handleAdd"
                  >新增</el-button>
      </el-col>
      
    </el-row>

    <el-table v-loading="loading" :data="userList">
          <el-table-column label="用户名称" align="center" key="userName" prop="userName"  :show-overflow-tooltip="true" />
         
          <el-table-column label="角色" align="center" key="roleId" prop="roleId"  width="120" >
            <template slot-scope="scope">
              <div>
                <span v-for="item in roleOptions" :key="item.id">
                  <span style="margin: 0 2px;" v-if="scope.row.roleIds && scope.row.roleIds.includes(item.roleId)">{{item.roleName}}</span> 
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态" key="status" align="center">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" :active-value="0" :inactive-value="1" @change="handleStatusChange(scope.row)" />
            </template>
          </el-table-column>
          <el-table-column label="创建时间" align="center" prop="createTime" width="160">
            <template slot-scope="scope">
              <span>{{ parseTime(scope.row.createTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="160" class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-button size="mini" type="text" icon="el-icon-edit" @click="handleUpdate(scope.row)"
                        >修改</el-button>

              <el-dropdown  @command="(command) => handleCommand(command, scope.$index, scope.row)">
                <span class="el-dropdown-link">
                  <i class="el-icon-d-arrow-right el-icon--right"></i>更多
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="handleDelete"  size="mini" type="text" icon="el-icon-delete"
                                    >删除</el-dropdown-item>
                  <el-dropdown-item command="handleResetPwd" size="mini" type="text" icon="el-icon-key"
                                    >重置密码</el-dropdown-item>
                  <!-- <el-dropdown-item command="handleRole" size="mini" type="text" icon="el-icon-circle-check"
                                    v-hasPermi="['system:permission:assign-user-role']">分配角色</el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>

        <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize"
          @pagination="getList"/>

    <!-- 添加或修改菜单对话框 -->
    <!-- 添加或修改参数配置对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item v-if="form.id === undefined" label="用户名称" prop="userName">
              <el-input v-model="form.userName" placeholder="请输入用户名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="form.id === undefined" label="用户密码" prop="password">
              <el-input v-model="form.password" placeholder="请输入用户密码" type="password" show-password />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row >
           <el-col :span="12">
           <el-form-item label="角色"  prop="roleIds">
              <el-select v-model="form.roleIds" placeholder="请选择" multiple>
                <el-option
                    v-for="item in roleOptions"
                    :key="item.roleId"
                    :label="item.roleName"
                    :value="item.roleId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
       
        <!-- 类型 1爱好者，2学生用户，3校园用户, 9管理员, 91 活动评委, 10 后台用户 -->
       
          <el-col :span="12">
            <el-form-item label="用户类型" prop="type">
               <el-select
                v-model="form.type"
                placeholder="请选择"
              >
                <el-option label="爱好者" :value="1"/>
                <el-option label="学生用户" :value="2"/>
                <el-option label="校园用户" :value="3"/>
                <!-- <el-option label="管理员" :value="9"/> -->
                <el-option label="活动评委" :value="91"/>
                <el-option label="后台用户" :value="10"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input v-model="form.remark" type="textarea" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" v-preventReClick :loading="btnLoading">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { $role , $user   } from "@/services/admin";

export default {
  name: "Menu",
  components: {  },
  data() {
    return { 
      // 遮罩层
      loading: true,
      // 显示搜索条件
      showSearch: true,
      // 菜单表格树数据
      userList: [],
      
      // 菜单树选项
      menuOptions: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 是否展开，默认全部折叠
      isExpandAll: false,
      // 重新渲染表格状态
      refreshTable: true,
      // 查询参数
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        userName: undefined,
        mobile: undefined,
        status: undefined,
        type: undefined
      },
      total:0,
      // 表单参数
      form: {},
      // 表单校验
       // 表单校验
       rules: {
        userName: [
          { required: true, message: "用户名称不能为空", trigger: "blur" }
        ],
        password: [
          { required: true, message: "用户密码不能为空", trigger: "blur" }
        ],
        email: [
          {
            type: "email",
            message: "'请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          }
        ],
        mobile: [
          {
            required: true,
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ],
        roleIds:[
          {
            required: true,
            message: "'请选择用户角色",
            trigger: ["blur", "change"]
          }
        ],
        type:[
          {
            required: true,
            message: "'请选择用户类型",
            trigger: ["blur", "change"]
          }
        ],
      },
      btnLoading:false,
      roleOptions:[],
  
    };
  },
  created() {

    this.getRoleList();

    this.getList();
  },
  methods: {
     // 更多操作
     handleCommand(command, index, row) {
      switch (command) {
        case 'handleUpdate':
          this.handleUpdate(row);//修改客户信息
          break;
        case 'handleDelete':
          this.handleDelete(row);//红号变更
          break;
        case 'handleResetPwd':
          this.handleResetPwd(row);
          break;
        case 'handleRole':
          this.handleRole(row);
          break;
        default:
          break;
      }
    },
    /** 重置密码按钮操作 */
    handleResetPwd(row) {
      this.$prompt('请输入"' + row.userName + '"的新密码', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(({ value }) => {
          row.password = value;
          $user.addUser( row ).then(() => {
            this.$message.success('修改成功');
          });
        }).catch(() => {});
    },
    //  角色列表
    async getRoleList(){
          let res = await $role.roleList({   pageNum: 1, pageSize: 99 })
          console.log( res )
          if( res.code == 200 ){
            this.roleOptions = res.data.records;
          }
    },
   
    /** 查询菜单列表 */
    getList() {
      this.loading = true;
      $user.userList(this.queryParams).then(response => {
        this.userList = response.data.records ;
        this.total = response.data.total;
        this.loading = false;
      });
    },
    /** 转换菜单数据结构 */
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.menuId,
        label: node.menuName,
        children: node.children
      };
    },
   
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        userName: undefined,
        password: undefined,
        // mobile: undefined,
        // email: undefined,
        // status: "0",
        remark: undefined,
        roleIds: []
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    /** 展开/折叠操作 */
    toggleExpandAll() {
      this.refreshTable = false;
      this.isExpandAll = !this.isExpandAll;
      this.$nextTick(() => {
        this.refreshTable = true;
      });
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset();
      row.id 
      this.open = true;
      this.title = "添加菜单";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      this.form = { ...row };
      this.open = true;
      this.title = "修改用户";
    },
    /** 提交按钮 */
     submitForm: function() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          if (this.form.id !== undefined) {
            $user.addUser(this.form).then(() => {
              this.btnLoading = false;
              this.$message.success('修改成功');
              this.open = false;
              this.getList();
            }).catch(()=>{ this.btnLoading = false; });
          } else {
            $user.addUser(this.form).then(() => {
               this.btnLoading = false;
               this.$message.success('新增成功');
              this.open = false;
              this.getList();
            }).catch(()=>{ this.btnLoading = false; });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      $user.delUser(row.id).then(() => {
          this.getList();
          this.$message.success('删除成功');
      }).catch(() => {});
   
    }
  }
};
</script>
